module.exports = __webpack_public_path__ + "static/media/Cheque.4f96b803.svg";